import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MAT_TABS_CONFIG, MatTabsModule } from '@angular/material/tabs';
import { tabsConfig } from '@xpo-ltl/ngx-ltl-core/common';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';

class XpoAlternateTabsDirective {
}
XpoAlternateTabsDirective.ɵfac = function XpoAlternateTabsDirective_Factory(t) { return new (t || XpoAlternateTabsDirective)(); };
XpoAlternateTabsDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoAlternateTabsDirective, selectors: [["", "xpo-alternate-tabs", ""], ["", "xpoAlternateTabs", ""]], hostAttrs: [1, "xpo-AlternateTabs"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAlternateTabsDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-alternate-tabs], [xpoAlternateTabs]',
                host: { class: 'xpo-AlternateTabs' },
            }]
    }], null, null); })();

/**
 * @deprecated use xpoAlternateTabs
 */
class XpoPrimaryTabs {
    constructor() {
        console.warn('WARN: xpo-primary-tabs has been deprecated, please use xpoAlternativeTabs');
    }
}
XpoPrimaryTabs.ɵfac = function XpoPrimaryTabs_Factory(t) { return new (t || XpoPrimaryTabs)(); };
XpoPrimaryTabs.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoPrimaryTabs, selectors: [["", "xpo-primary-tabs", ""]], hostAttrs: [1, "xpo-PrimaryTabs"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoPrimaryTabs, [{
        type: Directive,
        args: [{
                selector: '[xpo-primary-tabs]',
                host: { class: 'xpo-PrimaryTabs' },
            }]
    }], function () { return []; }, null); })();

class XpoTabsWideNavDirective {
}
XpoTabsWideNavDirective.ɵfac = function XpoTabsWideNavDirective_Factory(t) { return new (t || XpoTabsWideNavDirective)(); };
XpoTabsWideNavDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoTabsWideNavDirective, selectors: [["", "xpo-tabs-wide-nav", ""], ["", "xpoTabsWideNav", ""]], hostAttrs: [1, "xpo-TabsWideNav"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoTabsWideNavDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-tabs-wide-nav], [xpoTabsWideNav]',
                host: { class: 'xpo-TabsWideNav' },
            }]
    }], null, null); })();

class XpoPillTabGroupDirective {
}
XpoPillTabGroupDirective.ɵfac = function XpoPillTabGroupDirective_Factory(t) { return new (t || XpoPillTabGroupDirective)(); };
XpoPillTabGroupDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoPillTabGroupDirective, selectors: [["", "xpo-pill-tab-group", ""], ["", "xpoPillTabGroup", ""]], hostAttrs: [1, "xpo-PillTabGroup"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoPillTabGroupDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-pill-tab-group], [xpoPillTabGroup]',
                host: {
                    class: 'xpo-PillTabGroup',
                },
            }]
    }], null, null); })();

class XpoVerticalTabsDirective {
}
XpoVerticalTabsDirective.ɵfac = function XpoVerticalTabsDirective_Factory(t) { return new (t || XpoVerticalTabsDirective)(); };
XpoVerticalTabsDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoVerticalTabsDirective, selectors: [["", "xpo-vertical-tabs", ""], ["", "xpoVerticalTabs", ""]], hostAttrs: [1, "xpo-VerticalTabs"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoVerticalTabsDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-vertical-tabs], [xpoVerticalTabs]',
                host: { class: 'xpo-VerticalTabs' },
            }]
    }], null, null); })();

class XpoTabsModule {
}
XpoTabsModule.ɵfac = function XpoTabsModule_Factory(t) { return new (t || XpoTabsModule)(); };
XpoTabsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoTabsModule });
XpoTabsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [{ provide: MAT_TABS_CONFIG, useValue: tabsConfig }], imports: [[CommonModule, MatIconModule, MatTabsModule, MatMenuModule, XpoIconModule], MatTabsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoTabsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    XpoAlternateTabsDirective,
                    // tslint:disable-next-line: deprecation
                    XpoPrimaryTabs,
                    XpoTabsWideNavDirective,
                    XpoPillTabGroupDirective,
                    XpoVerticalTabsDirective,
                ],
                imports: [CommonModule, MatIconModule, MatTabsModule, MatMenuModule, XpoIconModule],
                exports: [
                    MatTabsModule,
                    XpoAlternateTabsDirective,
                    // tslint:disable-next-line: deprecation
                    XpoPrimaryTabs,
                    XpoTabsWideNavDirective,
                    XpoPillTabGroupDirective,
                    XpoVerticalTabsDirective,
                ],
                providers: [{ provide: MAT_TABS_CONFIG, useValue: tabsConfig }],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoTabsModule, { declarations: [XpoAlternateTabsDirective,
        // tslint:disable-next-line: deprecation
        XpoPrimaryTabs,
        XpoTabsWideNavDirective,
        XpoPillTabGroupDirective,
        XpoVerticalTabsDirective], imports: [CommonModule, MatIconModule, MatTabsModule, MatMenuModule, XpoIconModule], exports: [MatTabsModule,
        XpoAlternateTabsDirective,
        // tslint:disable-next-line: deprecation
        XpoPrimaryTabs,
        XpoTabsWideNavDirective,
        XpoPillTabGroupDirective,
        XpoVerticalTabsDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoAlternateTabsDirective, XpoPillTabGroupDirective, XpoPrimaryTabs, XpoTabsModule, XpoTabsWideNavDirective, XpoVerticalTabsDirective };
